import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CONTROLLER = API_URL + "/CertificationPackage"
const GET_VALID_COMPLETED_CERTIFICATION_PACKAGES = CONTROLLER + "/GetValidCompletedCertificationPackages"
const CREATE_NEW_CERITIFICATION_PACKAGE = CONTROLLER + "/CreateNewCertificationPackage"
const CREATE_REOPEN_CERITIFICATION_PACKAGE = CONTROLLER + "/CreateReopenCertificationPackage"
const GET_CERTIFICATION_PACKAGE = CONTROLLER + "/GetCertificationPackage"
const UPDATE_CERTIFICATION_PACKAGE = CONTROLLER + "/UpdateCertificationPackage"
const GET_CERTIFICATION_PACKAGE_CONSTANTS = CONTROLLER + "/GetCertificationPackageConstants"
const CANCEL_CERTIFICATION_PACKAGE = CONTROLLER + "/CancelCertificationPackage"
const GET_CERTIFICATION_PACKAGE_KEY_CONTACTS = CONTROLLER + "/GetCertificationPackageKeyContacts"
const UPDATE_CERTIFICATION_PACKAGE_KEY_CONTACTS = CONTROLLER + "/UpdateCertificationPackageKeyContacts"
const GET_CERTIFICATION_PACKAGE_DOCUMENT = CONTROLLER + "/GetCertificationPackageDocument"
const GET_CERTIFICATION_PACKAGE_SCREENSHOT = CONTROLLER + "/GetCertificationPackageScreenshot"
const GET_CERTIFICATION_PACKAGE_SCREENSHOTS = CONTROLLER + "/GetCertificationPackageScreenshots"
const DELETE_CERTIFICATION_PACKAGE_SCREENSHOT = CONTROLLER + "/DeleteCertificationPackageScreenshot"
const UPLOAD_CERTIFICATION_PACKAGE_SCREENSHOT = CONTROLLER + "/UploadCertificationPackageScreenshots"
const UPDATE_CERTIFICATION_PACKAGE_DOCUMENTS_ONLY = CONTROLLER + "/UpdateCertificationPackageDocumentsOnly"
const SUBMIT_CERTIFICATION_PACKAGE = CONTROLLER + "/SubmitCertificationPackage"
const RETURN_TO_CLIENT_CERTIFICATION_PACKAGE = CONTROLLER + "/ReturnToClientCertificationPackage"
const REJECT_CERTIFICATION_PACKAGE = CONTROLLER + "/RejectCertificationPackage"
const APPROVE_CERTIFICATION_PACKAGE = CONTROLLER + "/ApproveCertificationPackage"
const APPROVE_DEFERRED_CERTIFICATION_PACKAGE = CONTROLLER + "/ApproveDeferredCertificationPackage"
const REQUEST_REVIEW_CERTIFICATION_PACKAGE = CONTROLLER + "/RequestReviewCertificationPackage"
const DOWNLOAD_LETTER_CONTROLLER = API_URL + "/DownloadComplianceLetter"

const DownloadComplianceLetter = (bid, compApprovalId, packageId) => {
    let url = `${DOWNLOAD_LETTER_CONTROLLER}/${bid}?compApprovalId=${compApprovalId}&packageId=${packageId}`;
    return axios.get(url, { responseType: "blob" });
}

const GetValidCompletedCertificationPackages = (bid) => {
    let url = `${GET_VALID_COMPLETED_CERTIFICATION_PACKAGES}/${bid}`
    return axios.get(url);
}

const CreateReopenCertificationPackage = (bid, packageId) => {
    let url = `${CREATE_REOPEN_CERITIFICATION_PACKAGE}/${bid}`
    return axios.post(url, { prevPackageId: packageId });
}

const CreateNewCertificationPackage = (bid) => {
    let url = `${CREATE_NEW_CERITIFICATION_PACKAGE}/${bid}`
    return axios.post(url);
}

const GetCertificationPackage = (packageId) => {
    let url = `${GET_CERTIFICATION_PACKAGE}/${packageId}`
    return axios.get(url);
}

const UpdateCertificationPackage = (data) => {
    return axios.post(UPDATE_CERTIFICATION_PACKAGE, data)
}

const GetCertificationPackageConstants = () => {
    return axios.get(GET_CERTIFICATION_PACKAGE_CONSTANTS)
}

const CancelCertificationPackage = (packageId) => {
    let url = `${CANCEL_CERTIFICATION_PACKAGE}/${packageId}`
    return axios.post(url)
}

const UpdateCertificationPackageKeyContacts = (bid, data) => {
    let url = `${UPDATE_CERTIFICATION_PACKAGE_KEY_CONTACTS}/${bid}`
    return axios.post(url, data);
}

const GetCertificationPackageKeyContacts = (bid) => {
    let url = `${GET_CERTIFICATION_PACKAGE_KEY_CONTACTS}/${bid}`
    return axios.get(url);
}

const GetCertificationPackageDocument = (packageBid, packageId, requirement) => {
    let url = `${GET_CERTIFICATION_PACKAGE_DOCUMENT}/${packageBid}/${packageId}/${requirement}`
    return axios.get(url, { responseType: "blob" })
}

const UpdateCertificationPackageDocumentsOnly = (data) => {
    return axios.post(UPDATE_CERTIFICATION_PACKAGE_DOCUMENTS_ONLY, data);
}

const SubmitCertificationPackage = (bid, data) => {
    let url = `${SUBMIT_CERTIFICATION_PACKAGE}/${bid}`
    return axios.post(url, data)
}

const ReturnToClientCertificationPackage = (data) => {
    return axios.post(RETURN_TO_CLIENT_CERTIFICATION_PACKAGE, data)
}

const RejectCertificationPackage = (data) => {
    return axios.post(REJECT_CERTIFICATION_PACKAGE, data)
}

const ApproveCertificationPackage = (data) => {
    return axios.post(APPROVE_CERTIFICATION_PACKAGE, data)
}

const ApproveDeferredCertificationPackage = (data) => {
    return axios.post(APPROVE_DEFERRED_CERTIFICATION_PACKAGE, data)
}

const RequestReviewCertificationPackage = (data) => {
    return axios.post(REQUEST_REVIEW_CERTIFICATION_PACKAGE, data)
}

const GetCertificationPackageScreenshot = (packageId, guid) => {
    let url = `${GET_CERTIFICATION_PACKAGE_SCREENSHOT}/${packageId}/${guid}`
    return axios.get(url, { responseType: "blob" })
}
const GetCertificationPackageScreenshots = (packageId) => {
    let url = `${GET_CERTIFICATION_PACKAGE_SCREENSHOTS}/${packageId}`
    return axios.get(url, { responseType: "blob" })
}
const DeleteCertificationPackageScreenshot = (packageId, guid) => {
    let url = `${DELETE_CERTIFICATION_PACKAGE_SCREENSHOT}/${packageId}/${guid}`
    return axios.delete(url)
}
const UploadCertificationPackageScreenshots = (packageId, formData) => {
    let url = `${UPLOAD_CERTIFICATION_PACKAGE_SCREENSHOT}/${packageId}`
    return axios.post(url, formData, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const ceritificationPackageService = {
    GetValidCompletedCertificationPackages,
    CreateNewCertificationPackage,
    GetCertificationPackage,
    UpdateCertificationPackage,
    DownloadComplianceLetter,
    GetCertificationPackageConstants,
    CancelCertificationPackage,
    GetCertificationPackageKeyContacts,
    UpdateCertificationPackageKeyContacts,
    CreateReopenCertificationPackage,
    GetCertificationPackageDocument,
    GetCertificationPackageScreenshot,
    GetCertificationPackageScreenshots,
    DeleteCertificationPackageScreenshot,
    UploadCertificationPackageScreenshots,
    UpdateCertificationPackageDocumentsOnly,
    SubmitCertificationPackage,
    ReturnToClientCertificationPackage,
    RejectCertificationPackage,
    ApproveCertificationPackage,
    ApproveDeferredCertificationPackage,
    RequestReviewCertificationPackage
}